import { Group } from 'src/design/atoms/Group';
import { Stack } from 'src/design/atoms/Stack';
import { Text } from 'src/design/atoms/Text';
import React from 'react';
import { CreateButton } from 'src/design/atoms/CreateButton';

export interface IWorkflowDividerProps {
  showButton: boolean;
  onButtonClick?: () => void;
}

/** @registry Divider between workflow steps that reveals an "Add Step" button on hover-eligible steps. */
export const WorkflowDivider: React.FC<IWorkflowDividerProps> = ({
  showButton,
  onButtonClick,
}) => {
  const buttonClicked = () => {
    if (onButtonClick) {
      onButtonClick();
    }
  };

  return (
    <Stack gap="xs" align="center">
      {showButton ? (
        <Group justify="center">
          <CreateButton size="compact-sm" onClick={buttonClicked}>
            Add Step
          </CreateButton>
        </Group>
      ) : (
        <div style={{ height: 25 }} />
      )}
      <Text size="sm" c="dimmed">
        ▼
      </Text>
    </Stack>
  );
};
